export default "__VITE_ASSET__46974b40__"